{
  "pricing": {
    "loadingInfo": "Chargement des informations tarifaires...",
    "noPriceInfo": "Aucune information tarifaire disponible",
    "takeGoldmakingNextLevel": "Faites passer votre farm d'or au niveau supérieur",
    "subscribeFrom": "Abonnez-vous pour seulement {{price}} {{currency}} / mois. Sans engagement. Annulez à tout moment.",
    "goldSubActive": "Votre abonnement {{type}} actuel expire le {{expiration}}",
    "goldSubTitle": "Abonnement Gold actif",
    "goldSubUpgradeTitle": "Prêt à passer à Premium ?",
    "goldSubHeading": "Bon retour, faiseur d'or",
    "goldSubHeadingSubtitle": "Merci d'être membre Gold — voici votre abonnement en un coup d'œil.",
    "upgradeToPremiumContact": "Pour passer au premium, veuillez contacter notre équipe sur le",
    "discordName": "Discord Flipping Pal",
    "manageBilling": "Gérer la facturation et les méthodes de paiement",
    "manageBillingOpening": "Ouverture...",
    "monthly": "Mensuel",
    "yearly": "Annuel",
    "saveUpTo": "Économisez jusqu'à {{percent}}% avec un abonnement annuel.",
    "mostPopular": "Le plus populaire",
    "perMonth": "/mois",
    "perYear": "/an",
    "startDate": "Date de début : {{date}}",
    "nextPaymentDate": "Prochain paiement : {{date}}",
    "subscriptionEnds": "Fin de l'abonnement : {{date}}",
    "reasonPaymentFailed": "Raison : Paiement échoué",
    "reasonCancelled": "Raison : Annulé",
    "accessTools": "Accéder aux outils",
    "resumeSubscription": "Reprendre l'abonnement",
    "cancelSubscription": "Annuler l'abonnement",
    "processing": "Traitement...",
    "subscribeNow": "S'abonner maintenant",
    "getStarted": "Commencer",
    "switchToMonthly": "Passer au mensuel",
    "switchToYearly": "Passer à l'annuel",
    "upgradeToPremium": "Passer au Premium",
    "upgradeLabel": "Passer au Premium ({{billing}})",
    "downgradeToBasic": "Rétrograder au Basic",
    "downgradeLabel": "Rétrograder au Basic ({{billing}})",
    "switchPlan": "Changer de plan",
    "currentPlan": "Plan actuel",
    "statusActive": "Actif",
    "statusExpired": "Expiré",
    "statusCanceled": "Annulé",
    "statusInCancelation": "En cours d'annulation",
    "showMoreFeatures": "+ {{count}} fonctionnalités de plus",
    "showFewerFeatures": "Afficher moins"
  },
  "trial": {
    "activatedTitle": "Essai activé !",
    "activatedSubtitle": "Voici ce que vous obtenez — et ce qui vous attend",
    "startExploring": "Commencer à explorer",
    "viewPlans": "Voir les plans",
    "trialActive": "Essai gratuit actif",
    "daysRemaining": "{{count}} jour restant",
    "expires": "Expire le {{date}}",
    "trialLabel": "Essai",
    "compareButton": "Comparer les plans",
    "trialEnded": "Votre essai gratuit est terminé. Abonnez-vous ci-dessus pour continuer à utiliser FlippingPal !",
    "haveTrialCode": "Vous avez un code d'essai ?",
    "trialCodeHint": "Utilisez",
    "trialCodeHint2": "dans notre",
    "discordServer": "serveur Discord",
    "trialCodeHint3": "pour en obtenir un",
    "activateButton": "Activer l'essai",
    "activatingButton": "Activation"
  },
  "features": {
    "basic": {
      "0": "Limité à 10 royaumes de vente",
      "1": "Outil de housing pour flipper et dropper des décorations",
      "2": "Outil de flipping inter-royaumes",
      "3": "Outil de dropship limité à 3 résultats par objet",
      "4": "Statistiques de royaume",
      "5": "Générateur de liste TSM",
      "6": "Jusqu'à 50 alertes snipe d'objets pour Discord",
      "7": "Préréglages de filtres limités à 3",
      "8": "Support client de l'équipe"
    },
    "premium": {
      "0": "Royaumes de vente illimités",
      "1": "Outil de housing pour flipper et dropper des décorations",
      "2": "Outil de flipping inter-royaumes",
      "3": "Outil de dropship étendu à 10 résultats par objet",
      "4": "Statistiques de royaume",
      "5": "Générateur de liste TSM",
      "6": "Outil d'analyse d'inventaire",
      "7": "Jusqu'à 9999 alertes snipe d'objets pour Discord",
      "8": "Préréglages de filtres limités à 50",
      "9": "Partage de filtres avec fonction d'import/export",
      "10": "Support client de l'équipe",
      "11": "Support prioritaire"
    }
  },
  "loading": "Chargement des informations d'abonnement..."
}
